import { apiCrm } from '../../../../http';

class WebhookService {
  create(data) {
    return apiCrm.post(`webhook/`, data);
  }
  async getWithPagination({ page = 1, limit = 10, name = '' }) {
    let response = await apiCrm.get(`/webhook`, {
      params: {
        page,
        limit,
        name
      }
    });
    let count = await apiCrm.get(`/webhook`);
    response.data.count = count.data.data.length;
    return response;
  }
  changeStatus(id) {
    return apiCrm.put(`/webhook/status/${id}`);
  }
  update(id, data) {
    return apiCrm.put(`/webhook/${id}`, data);
  }
}

export default new WebhookService();
